import Inquiries from "../components/pages/User/Inquiries";
import ViewResults from "../components/pages/User/ViewResults"
import EditInquiry from "../components/pages/User/EditInquiry"

const userRoutes = [{
    path: '/onderzoeken/:token',
    component: Inquiries,
    name: 'inquiries'
}, {
    path: '/onderzoeken/:token/resultaten',
    component: ViewResults,
    name: 'view-results'
}, {
    path: '/onderzoeken/:token/aanpassen/:inquiryId',
    component: EditInquiry,
    name: 'edit-inquiry'
}];

export default userRoutes;
